import React, { forwardRef, useImperativeHandle, useState } from "react";
import BaseImport from "./index";

const BaseImportModal = forwardRef(({ dataName, apiURL, refetch }, ref) => {
  const [show, setShow] = useState(false);
  useImperativeHandle(ref, () => ({
    open: () => {
      setShow(true);
    },
    close: () => {
      setShow(false);
    },
  }));

  return (
    <BaseImport
      dataName={dataName}
      setShow={setShow}
      show={show}
      api={apiURL}
      refetch={refetch}
    />
  );
});

export default BaseImportModal;
